import { ArtworkColor } from '../types/gallery';

const COLOR_FILTER_STORAGE_KEY = 'schz-active-color-filter';

/**
 * Check if current execution is a browser page reload (e.g. F5 or Ctrl+R).
 */
export function isPageReload(): boolean {
  if (typeof window === 'undefined' || typeof performance === 'undefined') return false;
  try {
    const navEntries = performance.getEntriesByType('navigation');
    if (navEntries && navEntries.length > 0) {
      return (navEntries[0] as PerformanceNavigationTiming).type === 'reload';
    }
    // Fallback for older browsers
    return (performance as any).navigation?.type === 1;
  } catch (e) {
    return false;
  }
}

/**
 * Save the currently active color filter to sessionStorage.
 * If color is null, removes the stored filter.
 */
export function saveActiveColorFilter(color: ArtworkColor | null): void {
  if (typeof window === 'undefined') return;
  try {
    if (color) {
      sessionStorage.setItem(COLOR_FILTER_STORAGE_KEY, color);
    } else {
      sessionStorage.removeItem(COLOR_FILTER_STORAGE_KEY);
    }
  } catch (e) {
    console.warn('Failed to save color filter to sessionStorage:', e);
  }
}

/**
 * Retrieve the saved active color filter from sessionStorage.
 */
export function getSavedColorFilter(): ArtworkColor | null {
  if (typeof window === 'undefined') return null;
  try {
    const saved = sessionStorage.getItem(COLOR_FILTER_STORAGE_KEY);
    if (saved) {
      return saved as ArtworkColor;
    }
  } catch (e) {
    console.warn('Failed to retrieve color filter from sessionStorage:', e);
  }
  return null;
}

/**
 * Clear the saved color filter.
 */
export function clearActiveColorFilter(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(COLOR_FILTER_STORAGE_KEY);
  } catch (e) {
    // Ignore
  }
}

